import { AxiosInstance, AxiosResponse } from 'axios';
import { RevolutCard } from '../../models/revolut-card';
import ColisportApiResource from './colisport-api-resource.model';

export default class RevolutApi implements ColisportApiResource {
  readonly apiUrlPath = '/payment/revolut';

  constructor(readonly httpClient: AxiosInstance) {}

  /**
   * State of the Revolut order currently stored on the shipment (legacy API,
   * UPPERCASE states: PENDING/PROCESSING/AUTHORISED/COMPLETED/CANCELLED/FAILED).
   * Used before creating an order so an already-paid shipment is never
   * overwritten with a fresh unpaid order.
   */
  getOrderByColisportID(colisportID: string): Promise<AxiosResponse<{ state: string }>> {
    return this.httpClient.get(`${this.apiUrlPath}/orders/${colisportID}`);
  }

  getRevolutCustomer(token: string): Promise<
    AxiosResponse<{
      paymentMethods: RevolutCard[];
    }>
  > {
    return this.httpClient.get(`${this.apiUrlPath}/customer`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  /** Fetches payment methods via /payment-methods endpoint — includes subscription-saved cards. */
  getSubscriptionPaymentMethods(token: string): Promise<AxiosResponse<RevolutCard[]>> {
    return this.httpClient.get(`${this.apiUrlPath}/customer/subscription-payment-methods`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  payShipmentWithPaymentMethod(
    token: string,
    colisportID: string,
    paymentMethodID: string,
  ): Promise<AxiosResponse<{ any }>> {
    return this.httpClient.post(
      `${this.apiUrlPath}/customer`,
      {
        colisportID,
        paymentMethodID,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  }

  deleteUserPaymentMethod(token: string, publicID: string): Promise<AxiosResponse<RevolutCard[]>> {
    return this.httpClient.delete(`${this.apiUrlPath}/customer/payment-method/${publicID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  async createPaymentLink(colisportID: string, amount: number, currency: string): Promise<any> {
    return this.httpClient.post(`${this.apiUrlPath}/createPaymentLink`, {
      colisportID,
      amount,
      currency,
    });
  }
}
